import React from 'react';
import NumberFormat from 'react-number-format';

interface PhoneNumberProps {
    inputRef: (instance: NumberFormat | null) => void,
  name: string,
  onChange: (event: { target: { name: string; value: string; }}) => void,
}

const phoneNumberField: React.FC<PhoneNumberProps> = (props: PhoneNumberProps) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <>
      <NumberFormat
        {...other}
        format="+1 (###) ###-####"
        mask="_"
        decimalScale={0}
        fixedDecimalScale={true}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        isNumericString
      />
    </>
  );

}

export default phoneNumberField;